// import Http from './http'; // não precisa de .js
import axios from "axios";
import api from "../utils/api";

// const token = !localStorage.getItem('token')?false:localStorage.getItem('token')
const token = localStorage.getItem("token");
if (token) axios.defaults.headers.get["Authorization"] = "Bearer " + token;
axios.defaults.headers.get["Content-Type"] = "application/json";

const config = {
  headers: {
    Authorization: "Bearer " + token,
    "Access-Control-Allow-Origin": "*",
  },
};

export const getCEP = (data, version) => {
  if (version && version == "2")
    return api.get(process.env.VUE_APP_CEP_API + "2?cep=" + data, config);
  else if (version && version == "correios")
    return api.get(
      process.env.VUE_APP_CORREIOS_CEP_API + "?cep=" + data,
      config,
    );
  return api.get(process.env.VUE_APP_CEP_API + "?cep=" + data, config);
};
